import React from 'react';
import { Spin } from 'antd';

const LazyExpirationPurchasePage = React.lazy(() => import('./ExpirationPurchase'));
export const AsyncExpirationPurchasePage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyExpirationPurchasePage />
	</React.Suspense>
);
